<template>
  <v-form v-model="valid">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>Wysyłka SMS</v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-select :items="itemsToSelect" v-model="selectedSmsNumber" label="Wybierz branke sms" ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select :items="szablonySms" v-model="wybranySzablon" label="Wybierz szablon sms" ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="wybranySzablon == 'Wiadomość'">
                  <v-col cols="12">
                    <v-autocomplete
                        v-model="wybraniPacjenci"
                        id="clientId"
                        name="clientId"
                        :loading="isLoadingClients"
                        :items="clientsList"
                        :search-input.sync="clientKeyword"
                        cache-items
                        flat
                        no-data-text="Nieznaleziono"
                        hide-details
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        item-value="id"
                        item-text="name_surname"
                        label="Wyszukaj pacjenta Imię/Nazwisko/PESEL/Numer Telefonu"
                    >
                      <template v-slot:item="data">
                        <v-container fluid>
                          <v-row no-gutters>
                            <v-col>
                              {{data.item.name + ' '+data.item.surname}}
                            </v-col>
                            <v-col>
                              {{ data.item.description != null ? data.item.description.substr(0,19) : ''}}
                            </v-col>
                            <v-col>
                              {{data.item.pesel}}
                            </v-col>
                            <v-col class="text-right">
                              <v-icon class="mr-2">fa-phone</v-icon>{{data.item.phone}}
                            </v-col>
                          </v-row>
                        </v-container>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="wybranySzablon == 'Wiadomość' || wybranySzablon == 'Informacyjny'">
                  <v-col cols="12">
                    <v-textarea v-if="wybranySzablon == 'Wiadomość'" label="Treśc wiadomości" v-model="trescWiadomosci" rows="3"></v-textarea>
                    <v-textarea v-if="wybranySzablon == 'Informacyjny'"  hint="Specjalne wstawki: %dw% - data wizyty, %gw% - godzina wizyty, %tw% - imie i nazwisko terapeuty" label="Treśc wiadomości" v-model="trescWiadomosci" rows="3"></v-textarea>
                  </v-col>
                </v-row>
                <v-row v-if="wybranySzablon == 'Odwołanie'">
                  <v-col cols="12">
                    <v-select :items="powodyOdwolania" v-model="wybranyPowodOdwolania" label="Wybierz powód odwołania" ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="wybranySzablon == 'Opóźnienie'">
                  <v-col cols="12">
                    <ejs-numerictextbox v-model:value="wartoscOpoznienia" format="### minut" value="0" min="0"></ejs-numerictextbox>
                  </v-col>
                </v-row>
                <v-row v-if="wybranySzablon == 'Odwołanie' || wybranySzablon == 'Opóźnienie' || wybranySzablon == 'Informacyjny'">
                  <v-col cols="12" md="6">
                    <ejs-datetimepicker v-model:value="dataGodzinaStart" placeholder="Początkowa data i godzina wizyt" :openOnFocus="openFocus" @change="changeDate"></ejs-datetimepicker>
                  </v-col>
                  <v-col cols="12" md="6">
                    <ejs-datetimepicker v-model:value="dataGodzinaKoniec" placeholder="Końcowa data i godzina wizyt" :openOnFocus="openFocus" @change="changeDate"></ejs-datetimepicker>
                  </v-col>
                </v-row>
                <v-row v-if="(wybranySzablon == 'Odwołanie' || wybranySzablon == 'Opóźnienie' || wybranySzablon == 'Informacyjny') && therapistList.length > 0">
                  <v-col cols="12">
                    <v-select :label="pracownicy_label" multiple v-model="wybraniTerapeuci" :items="therapistList"  item-text="fullName" item-value="id" chips small-chips deletable-chips>
                      <v-list-item
                          slot="prepend-item"
                          ripple
                      >
                        <v-list-item-action>
                          <v-btn color="primary" class="ma-2" @click="selectAll">Wybierz wszystkich</v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider
                          slot="prepend-item"
                          class="mt-2"
                      />
                    </v-select>
                  </v-col>
                </v-row>
                <v-row v-if="(wybranySzablon == 'Odwołanie' || wybranySzablon == 'Opóźnienie' || wybranySzablon == 'Informacyjny') && filteredClients.length > 0">
                  <v-col cols="12">
                    <v-select multiple v-model="wykluczeniPacjenci"  label="Wykluczeni klienci" :items="filteredClients" item-text="fullName" item-value="id" chips small-chips deletable-chips></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field label="Liczba odbiorców wiadomości" v-model="ilosc_wiadomosci" disabled></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-textarea rows="3" v-if="wybranySzablon != 'Wiadomość' && wybranySzablon != 'Informacyjny'" label="Podgląd sms" disabled v-model="szablon_podglad"></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="Send">Wyślij sms</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-form>
</template>

<script>

import dayjs from "dayjs";
import Vue from "vue";
import swal from "sweetalert";
import {clientService, settingsService, visitService} from "@/services";
import { DateTimePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import i18next from "i18next";
Vue.use(DateTimePickerPlugin);
Vue.use(NumericTextBoxPlugin);
export default {
  name: "SendSMS",
  props: {
    initialPhone: {
      type: String,
      default: null
    },
    initialClientId: {
      type: [Number, String],
      default: null
    },
    initialTemplate: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      valid : true,
      isLoading: false,
      companySettings: null,
      selectedSmsNumber: null,
      szablonySms: null,
      wybranySzablon: null,
      wybraniPacjenci: [],
      trescWiadomosci: null,
      isLoadingClients: false,
      clientsList: [],
      powodyOdwolania: ['z powodu choroby', 'z powodu nieobecności', 'z powodu awarii'],
      wybranyPowodOdwolania: null,
      clientKeyword: null,
      wykluczeniPacjenci: [],
      dataGodzinaStart: new Date(),
      dataGodzinaKoniec: null,
      openFocus: true,
      visitsSummary: null,
      therapistList: [],
      wybraniTerapeuci: [],
      pacjenciList: [],
      pracownicy_label: 'Pracownicy',
      wartoscOpoznienia: 0
    }
  },
  mounted() {
    this.pracownicy_label = i18next.t('FE_PRACOWNICY')
    this.isLoading = true
    settingsService.GetCompanySettings().then(success=> {
      if(success.data.result)
      {
        this.companySettings = success.data.result
        this.selectedSmsNumber = this.companySettings.smsNumber

        this.szablonySms = ['Wiadomość','Informacyjny']


        if(this.companySettings.szablon_sms_odwolanie && this.companySettings.szablon_sms_odwolanie.length > 0)
          this.szablonySms.unshift('Odwołanie')

        if(this.companySettings.szablon_sms_opoznienie && this.companySettings.szablon_sms_opoznienie.length > 0)
          this.szablonySms.unshift('Opóźnienie')

/*        if(this.companySettings.szablon_sms_zaproszenie && this.companySettings.szablon_sms_zaproszenie.length > 0)
          this.szablonySms.unshift('Zaproszenie')*/

        this.isLoading = false

        // Handle query params for pre-filling from SMS Center
        this.handleQueryParams()
      }
      else
      {
        throw 'error'
      }
    }).catch(error => {
      console.log(error)
      this.showError("Błąd pobierania ustawień firmy.")
      this.isLoading = false
    })
  },
  methods: {
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      })
    },
    handleQueryParams() {
      // Props take precedence over query params
      const phone = this.initialPhone || this.$route.query.phone;
      const template = this.initialTemplate || this.$route.query.template;
      const clientId = this.initialClientId || this.$route.query.clientId;
      const isFromProps = this.initialPhone || this.initialClientId || this.initialTemplate;

      if (template) {
        this.wybranySzablon = template;
      }

      // If clientId is provided, add client directly
      if (clientId) {
        clientService.get(clientId).then(response => {
          if (response.data.result) {
            const client = response.data.result;
            this.clientsList.push({
              id: client.id,
              name: client.name,
              surname: client.surname,
              pesel: client.pesel,
              therapist: client.therapistID,
              full_text: client.name + ' ' + client.surname + (client.pesel ? ' ' + client.pesel : '') + (client.phone ? ' ' + client.phone : ''),
              disabled: false,
              description: client.description,
              phone: client.phone,
              name_surname: client.name + ' ' + client.surname
            });
            this.wybraniPacjenci = [client.id];
          }
          // Clean up URL only if from query params
          if (!isFromProps && this.$route.query.clientId) {
            this.$router.replace({ path: "/sms" });
          }
        }).catch(() => {
          if (!isFromProps && this.$route.query.clientId) {
            this.$router.replace({ path: "/sms" });
          }
        });
      } else if (phone) {
        // Search by phone number
        clientService.getAll({ query: phone, page: 1, limit: 10, sorting: "surname" }).then(response => {
          if (response.data.result && response.data.result.items.length > 0) {
            response.data.result.items.forEach(client => {
              if (!this.clientsList.find(x => x.id === client.id)) {
                this.clientsList.push({
                  id: client.id,
                  name: client.name,
                  surname: client.surname,
                  pesel: client.pesel,
                  therapist: client.therapistID,
                  full_text: client.name + ' ' + client.surname + (client.pesel ? ' ' + client.pesel : '') + (client.phone ? ' ' + client.phone : ''),
                  disabled: false,
                  description: client.description,
                  phone: client.phone,
                  name_surname: client.name + ' ' + client.surname
                });
              }
            });
            // Select the first matching client
            this.wybraniPacjenci = [response.data.result.items[0].id];
          }
          // Clean up URL only if from query params
          if (!isFromProps && this.$route.query.phone) {
            this.$router.replace({ path: "/sms" });
          }
        }).catch(() => {
          if (!isFromProps && this.$route.query.phone) {
            this.$router.replace({ path: "/sms" });
          }
        });
      }
    },
    Send() {
      if(this.wybranySzablon == null || this.wybranySzablon.length == 0)
      {
        this.showError('Nie wybrano szablonu')
        return
      }
      if(this.wybranySzablon == 'Wiadomość' && this.wybraniPacjenci.length == 0)
      {
        this.showError("Wybierz pacjentów")
        return
      }
      if(this.wybranySzablon == 'Wiadomość' && (this.trescWiadomosci == null || this.trescWiadomosci.length == 0))
      {
        this.showError("Wprowadź treśc wiadomości.")
        return
      }

      if(this.wybranySzablon == 'Odwołanie' || this.wybranySzablon == 'Opóźnienie' || this.wybranySzablon == 'Informacyjny')
      {
        if(this.dataGodzinaStart == null || this.dataGodzinaKoniec == null)
        {
          this.showError('NIe wybrano przedziału dat/godzin.')
          return
        }
        if(this.wybraniTerapeuci.length == 0)
        {
          this.showError('Nie wybrano terapeutów.')
          return
        }
        if(this.wybranySzablon == 'Odwołanie' && this.wybranyPowodOdwolania == null)
        {
          this.showError('Nie wybrano powodu odwołania')
          return
        }
        if(this.wybranySzablon == 'Opóźnienie' && this.wartoscOpoznienia <= 0)
        {
          this.showError('Proszę podać prawidłową wartośc opóźnienia')
          return
        }
        if(this.wybranySzablon == 'Informacyjny' && !this.trescWiadomosci)
        {
          this.showError('Nie podano treści wiadomości')
          return
        }
      }
      let dataToSend = {}

      dataToSend['wybranySzablon'] = this.wybranySzablon
      if(this.wybranySzablon == 'Wiadomość')
      {
        dataToSend['trescWiadomosci'] = this.trescWiadomosci
        dataToSend['wybraniPacjenci'] = this.wybraniPacjenci
      }
      if(this.wybranySzablon == 'Odwołanie' || this.wybranySzablon == 'Opóźnienie' || this.wybranySzablon == 'Informacyjny')
      {
        dataToSend['dataStart'] = this.dataGodzinaStart
        dataToSend['dataKoniec'] = this.dataGodzinaKoniec
        dataToSend['wybraniTerapeuci'] = this.wybraniTerapeuci
        dataToSend['wykluczeniPacjenci'] = this.wykluczeniPacjenci
        if(this.wybranySzablon == 'Odwołanie')
          dataToSend['wybranyPowodOdwolania'] = this.wybranyPowodOdwolania
        if(this.wybranySzablon == 'Opóźnienie')
          dataToSend["wartoscOpoznienia"] = this.wartoscOpoznienia
        if(this.wybranySzablon == 'Informacyjny')
          dataToSend['trescWiadomosci'] = this.trescWiadomosci
      }
      this.isLoading = true
      visitService.sendSMS(dataToSend).then(()=> {
        swal({
          title: "Sukces!",
          text: 'Wysłano',
          icon: "success",
          button: "OK"
        })
        this.wybraniPacjenci = []
        this.trescWiadomosci = null
        this.wybranyPowodOdwolania = null
        this.wykluczeniPacjenci = []
        this.dataGodzinaStart = new Date()
        this.dataGodzinaKoniec = null
        this.wybraniTerapeuci = []
        this.therapistList = []
        this.pacjenciList = []
        this.wybranySzablon = null
        this.isLoading = false
      }).catch(err=> {
        if(err.response != null && err.response.data != null && err.response.data.error != null)
        {
          this.showError(err.response.data.error.message)
        }
        else
        {
          this.showError('Błąd wysyłki sms')
        }
        this.isLoading = false
      })
    },
    selectAll()
    {
      let wyb = []
      this.therapistList.forEach(elem=> {
        wyb.push(elem.id)
      })
      this.wybraniTerapeuci =wyb
    },
    changeDate()
    {
      if(this.dataGodzinaStart && this.dataGodzinaKoniec)
      {
        this.isLoading = true
        visitService.getVisitsSummaryForSms(this.dataGodzinaStart, this.dataGodzinaKoniec).then(result=> {
          this.wybraniTerapeuci = []
          this.wykluczeniPacjenci = []
          this.therapistList = result.data.result.therapists
          this.pacjenciList = result.data.result.clients


          this.isLoading = false
        }).catch(err => {
          this.isLoading = false
          if(err.response != null && err.response.data != null && err.response.data.error != null)
          {
            this.showError(err.response.data.error.message)
          }
          else
          {
            this.showError('Błąd sprawdzanie wizyt')
          }
        })
      }
    },
    getClientValues(val) {
      this.isLoadingClients = true;
      clientService
          .getAll({query: val, page: 1, limit: 20, sorting: "surname"})
          .then(data => {
            data.data.result.items.forEach(item => {
              if (!this.clientsList.find(x => x.id === item.id)) {
                this.clientsList.push({
                  id: item.id,
                  name: item.name,
                  surname: item.surname,
                  pesel: item.pesel,
                  therapist: item.therapistID,
                  full_text: item.name + ' '+item.surname + (item.pesel != null && item.pesel != '' ? ' '+item.pesel : '') + (item.phone != null && item.phone != '' ? ' '+item.phone : ''),
                  disabled:false,
                  description: item.description,
                  phone: item.phone,
                  name_surname: item.name + ' ' + item.surname
                });
              }
            });
            this.isLoadingClients = false;
          })
          .catch(() => {
            this.isLoadingClients = false;
            this.showError( "Nie można pobrać listy klientów.");
          });
    },
  },
  computed:
  {
    filteredClients: function() {
      if(this.wybraniTerapeuci.length == 0)
        return []
      else {
        return this.pacjenciList.filter(x => this.wybraniTerapeuci.includes(x.therapistID))
      }
    },
    itemsToSelect: function() {
      if(this.companySettings)
      {
        return [this.companySettings.smsNumber]
      }
      else
      {
        return null
      }
    },
    ilosc_wiadomosci: function() {
      if(this.wybranySzablon == 'Wiadomość')
        return this.wybraniPacjenci.length
      else
        return this.filteredClients.length - this.wykluczeniPacjenci.length
    },
    szablon_podglad: function() {
      if(this.wybranySzablon != null)
      {
        let szablon_txt = ''
        if(this.wybranySzablon == 'Odwołanie')
          szablon_txt = this.companySettings.szablon_sms_odwolanie

        if(this.wybranySzablon == 'Opóźnienie')
          szablon_txt = this.companySettings.szablon_sms_opoznienie

        if(this.wybranySzablon == 'Zaproszenie')
          szablon_txt = this.companySettings.szablon_sms_zaproszenie

        return szablon_txt.replace('%dw%','___data_wizyty___').replace('%tw%','___imie_nazwisko_specjalisty___').replace('%gw%','___godzina_wizyty___').replace('%opoznienie%','___opoznienie_wizyty_w_minutach___').replace("%powod_odwolania%","___powod_odwolania___")
      }
    }
  },
  watch:{
    clientKeyword(val) {
      if (val) {
        this.getClientValues(val);
      }
    },
    wybranySzablon(val,oldval)
    {
      if(val != oldval)
      {
        this.wybraniPacjenci = []
        this.trescWiadomosci = null
        this.wybranyPowodOdwolania = null
        this.wykluczeniPacjenci = []
        this.dataGodzinaStart = new Date()
        this.dataGodzinaKoniec = null
        this.wybraniTerapeuci = []
        this.therapistList = []
        this.pacjenciList = []
      }
    }
  }
}
</script>

<style scoped>

</style>